import { render, staticRenderFns } from "./goodslist.vue?vue&type=template&id=63697b02&scoped=true&"
import script from "./goodslist.vue?vue&type=script&lang=js&"
export * from "./goodslist.vue?vue&type=script&lang=js&"
import style0 from "./goodslist.vue?vue&type=style&index=0&id=63697b02&scoped=true&lang=css&"
import style1 from "./goodslist.vue?vue&type=style&index=1&id=63697b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63697b02",
  null
  
)

export default component.exports